import React from 'react'

import StyleguidePreview from 'components/styleguide-preview'
import HeaderNavBar from 'components/header-nav-bar'

import AddDatesIcon from '../../../assets/icons/add-dates.svg'
import EventDetailsIcon from '../../../assets/icons/details.svg'
import IntegrationsIcon from '../../../assets/icons/integrations.svg'
import ViewIcon from '../../../assets/icons/view.svg'

const HeaderNavBarPreview = () => {
  const group1 = [
    { label: 'Add Dates', icon: <AddDatesIcon />, active: true },
  ]

  const group2 = [
    { label: 'Event Details', icon: <EventDetailsIcon /> },
    { label: 'Integrations', icon: <IntegrationsIcon /> },
  ]

  const group3 = [
    { label: 'View', icon: <ViewIcon />, secondary: true },
  ]

  return (
    <StyleguidePreview dark spacing="vertical" title="Event Nav Bar">
      <HeaderNavBar items={group1} />
      <HeaderNavBar items={group2} />
      <HeaderNavBar items={group3} />
    </StyleguidePreview>
  )
}

export default HeaderNavBarPreview



/** WEBPACK FOOTER **
 ** ./src/containers/styleguide/header-nav-bar-preview.js
 **/